/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Signin_BodyInputs */

const en_invite_signin_body = /** @type {(inputs: Invite_Signin_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the account the invite was sent to.`)
};

/** @type {(inputs: Invite_Signin_BodyInputs) => LocalizedString} */
const ar_invite_signin_body = en_invite_signin_body;

/** @type {(inputs: Invite_Signin_BodyInputs) => LocalizedString} */
const he_invite_signin_body = en_invite_signin_body;

/** @type {(inputs: Invite_Signin_BodyInputs) => LocalizedString} */
const ur_invite_signin_body = en_invite_signin_body;

/** @type {(inputs: Invite_Signin_BodyInputs) => LocalizedString} */
const es_invite_signin_body = en_invite_signin_body;

/** @type {(inputs: Invite_Signin_BodyInputs) => LocalizedString} */
const fr_invite_signin_body = en_invite_signin_body;

/** @type {(inputs: Invite_Signin_BodyInputs) => LocalizedString} */
const de_invite_signin_body = en_invite_signin_body;

/** @type {(inputs: Invite_Signin_BodyInputs) => LocalizedString} */
const pt_invite_signin_body = en_invite_signin_body;

/** @type {(inputs: Invite_Signin_BodyInputs) => LocalizedString} */
const hi_invite_signin_body = en_invite_signin_body;

/** @type {(inputs: Invite_Signin_BodyInputs) => LocalizedString} */
const bn_invite_signin_body = en_invite_signin_body;

/**
* | output |
* | --- |
* | "Use the account the invite was sent to." |
*
* @param {Invite_Signin_BodyInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_signin_body = /** @type {((inputs?: Invite_Signin_BodyInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Signin_BodyInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_signin_body(inputs)
	if (locale === "he") return he_invite_signin_body(inputs)
	if (locale === "ur") return ur_invite_signin_body(inputs)
	if (locale === "es") return es_invite_signin_body(inputs)
	if (locale === "fr") return fr_invite_signin_body(inputs)
	if (locale === "de") return de_invite_signin_body(inputs)
	if (locale === "pt") return pt_invite_signin_body(inputs)
	if (locale === "hi") return hi_invite_signin_body(inputs)
	if (locale === "bn") return bn_invite_signin_body(inputs)
	return /** @type {LocalizedString} */ ("Use the account the invite was sent to.")
});